import { createContext } from 'react';

const DialogContext = createContext();

export const DialogProvider = DialogContext.Provider;
export default DialogContext;
